const { getLanguage } = require('core/i18n').i18n;
let currentLanguage = getLanguage();

module.exports = {
    FINANCES_NEWS: 'FINANCES_NEWS',
    LAST_NEWS: 'LAST_NEWS',
    ALL_OPTIONS: 'TODAS',
    DETAIL_NEW: 'DETAIL_NEW',
    OTHER_NEWS: 'OTHER_NEWS',
    MAX_LAST_NEWS: 5,
    MAX_FINANCES_NEWS: 2,
    MAX_INDEX_GRAPH_ACCORDION: 365,
    MAX_FINANCES_NEWS_VIEW: 15,
    FILTERS_CHART_INDEXES: [
        {
            label:  'brokerMarketNews-oneDayFilter',
            value: 1
        },
        {
            label:  'brokerMarketNews-oneWeekFilter',
            value: 7
        },
        {
            label:  'brokerMarketNews-oneMonthFilter',
            value: 30
        },
        {
            label:  'brokerMarketNews-oneYearFilter',
            value: 365
        },
        {
            label:  'brokerMarketNews-threeYearsFilter',
            value: 1095
        },
    ],
    CHART_PROPS: {
        dataXaxis:"date",
        dataChart:["low"],
        colorChart:["#4CDEF0"],
        typeChart:["AREA"],
        typeChartBrush:["AREA"],
        typeXaxis:"TIME",
        formatTime:"MMM YYYY",
        referenceLineColor:"#4CDEF0",
        showBrush:false,
        showReferenceLineTop:false,
        showReferenceLineBottom:false,
        showDot:[false],
        language: currentLanguage,
        lineStrokeWidth:1,
        showLegend:false,
        strokeDashCartesian:"0 0",
        showVerticalCartesianGrid:false,
    }
};
